import { TSToChartEvent } from '@thoughtspot/ts-chart-sdk';
import { sendMessage } from '../../../services/post-message-event-dispatcher';
import { triggerChartReRender } from '../trigger-chart-re-render';
import { triggerUpdateChartModel } from '../update-chart-model';
export const triggerUpdateVisualProps = (commonProps, eventProps, emitEvent, triggerRenderChart = true) => {
    const { iFrameWindow: iframeRef, appUrl } = commonProps;
    const { visualProps } = eventProps;
    const payload = {
        eventType: TSToChartEvent.VisualPropsUpdate,
        payload: {
            visualProps,
        },
    };
    return sendMessage(iframeRef, payload, appUrl).then(async (res) => {
        if (res.data.triggerUpdateChartModel === true) {
            await triggerUpdateChartModel(commonProps, eventProps.updateChartModelProps, emitEvent);
        }
        if (res.data.triggerRenderChart === true && triggerRenderChart) {
            return triggerChartReRender(commonProps);
        }
        return res;
    });
};
//# sourceMappingURL=index.js.map